import type { ReactNode } from 'react'
import { Footer } from '../components/Footer'
import { SiteHeader } from '../components/SiteHeader'
import styles from './LegalPage.module.css'

interface LegalLayoutProps {
  title: string
  lede: string
  children: ReactNode
}

export function LegalLayout({ title, lede, children }: LegalLayoutProps) {
  return (
    <div className={styles.page}>
      <SiteHeader />
      <main id="main-content" className={styles.main}>
        <article className={styles.article}>
          <header className={styles.header}>
            <p className={styles.eyebrow}>Gesturely legal</p>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.lede}>{lede}</p>
            <p className={styles.effective}>Effective September 8, 2026</p>
          </header>
          <div className={styles.content}>{children}</div>
        </article>
      </main>
      <Footer />
    </div>
  )
}
